<template>
    <div class="panel panel-default">
        <div class="panel-heading">
            <h5>
                Additional Information
            </h5>
        </div>

        <div class="panel-body">
            <textarea-form-group
                    v-model="orderConfirmation.message"
                    name="message"
                    label="Message"
                    help-text="A message to put on the order confirmation."
                    :error="getError('message')"
            ></textarea-form-group>

            <select-form-group
                    :value="orderConfirmation.legal_text_id"
                    name="legal_text_id"
                    label="Legal Text"
                    help-text="Any legal text to print on the last page."
                    :error="getError('legal_text_id')"
                    :options="legalTextOptions"
                    @input="update('legal_text_id', $event)"
            ></select-form-group>
        </div>
    </div>
</template>

<script>
    import Errors from '@/mixins/Errors'
    import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
    import TextareaFormGroup from '@/vendor/forms/FormGroups/Block/Textarea'

    export default {
        components: {SelectFormGroup, TextareaFormGroup},

        model: {
            prop: 'orderConfirmation',
            event: 'order-confirmation-updated'
        },

        mixins: [Errors],

        props: ['orderConfirmation', 'legalTexts'],


        computed: {
            legalTextOptions() {
                return this.legalTexts.data.map(legalText => {
                    return {
                        value: legalText.id,
                        label: legalText.attributes.name
                    }
                })
            }
        },

        methods: {
            update(key, value) {
                this.$emit('order-confirmation-updated', {...this.orderConfirmation, [key]: value})
            }
        }
    }
</script>
